export default {
    streamNoteListedWebpages:
        'Please note, the listed webpages are not the property of Netvork LLP',
    streamNoteAdministrationCompliance:
        'Their administration and their owners compliance with applicable law is not the responsibility of Netvork LLP.',
    streamNoteReportEmail:
        'If you have any problems with the landing pages, please report them to email',
    respectfullyTeam: 'Respectfully, the Netvork Team',
    enterMessengerAccount: 'Enter messenger account',
    invalidTelegram: 'Invalid Telegram address',
    invalidSkype: 'Invalid Skype/Teams address',
};
